import React, { ChangeEvent, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import Checkbox from 'components/checkbox';
import { ISelectionFormValues } from '../../../utils/types';

export const SaveToLibraryCheckbox: FC = () => {
  const form = useFormContext<Pick<ISelectionFormValues, 'saveToLibrary'>>();

  const checked = form.watch('saveToLibrary');

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    form.setValue('saveToLibrary', event.target.checked);
  };

  return (
    <Grid
      item
      xs
      component="div"
      display="flex"
      flexDirection="row"
      gap={1}
      alignItems="inherit"
      sx={{ alignItems: 'inherit' }}
    >
      <Checkbox checked={checked} onChange={onChange} />
      <Typography component="div" sx={{ fontSize: '12px', fontFamily: 'Inter' }}>
        Save to Selections Library
      </Typography>
    </Grid>
  );
};
